import { Link } from "gatsby";
import OneColumnLayout from "../../../../src/components/templates/one-column-layout";
import Head from "../../../../src/components/head";
import * as React from 'react';
export default {
  Link,
  OneColumnLayout,
  Head,
  React
};